import { PayloadAction } from "@reduxjs/toolkit";
import { SessionState } from "../session.slice.ts";

export const setIsWebsocketConnectedReducer = (
  state: SessionState,
  action: PayloadAction<boolean>,
) => {
  state.isWebsocketConnected = action.payload;
};
